// Used in assignables.component.html, resources-list.component.html, and assignables-list.component.html

// Angular
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";

// Services/Types/Helpers
import { AssetAssociationsHelper } from "#helpers/asset-associations.helper";
import { LanguageHelper } from "#helpers/language.helper";
import {
    SelectedAssets,
} from "cli-types";
// RXJS/Store
import { LevelId, SubjectId } from "@carnegie-learning/common-types";
import { Asset, AssetAssociation, IPA, assetActivityTypeIds, assetTypeIds } from "@carnegie-learning/cure-types";
import { AssetsService } from "@carnegie-learning/data-access-angular-cure";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "assignable-expanded-composite",
    templateUrl: "./assignable-expanded-composite.component.html",
    styleUrls: ["./assignable-expanded-composite.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CompositeAssignableComponent implements OnInit, OnDestroy {
    displayedColumns = ["type", "activity"];
    readonly assetTypeIds = assetTypeIds;
    readonly assetActivityTypeIds = assetActivityTypeIds;
    private ngUnsubscribe = new Subject();

    @Input() asset: IPA;
    @Input() selectedAssets: SelectedAssets;
    @Input() creatingLesson: boolean;
    @Input() subjects: AssetAssociation[];

    @Output() toggleCategoryEvent = new EventEmitter<any>();

    @ViewChild(MatPaginator) paginator: MatPaginator;

    constructor(
        private languageHelper: LanguageHelper,
        private assetAssociationsHelper: AssetAssociationsHelper,
        private assetsService: AssetsService
    ) {}

    ngOnInit() {
        this.assetsService
            .getSelectedAsset(this.asset.assetId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((asset: Asset) => {
                if (asset) {
                    this.asset = <IPA>asset;
                }
            });
    }

    getImagePath(asset: Asset) {
        return "assets/images/Module/" + (<IPA>asset).image + ".jpg";
    }

    getIPAIntegrationGuideUrl(asset: Asset) {
        return this.languageHelper.getIPAIntegrationGuideUrl(asset.subjectId);
    }
    getIPAScoringGuideUrl(levelId: LevelId) {
        return this.languageHelper.getIPAScoringGuideUrl(levelId);
    }
    getLevelDisplayName(subjectId: SubjectId, levelId: LevelId) {
        return this.assetAssociationsHelper.getLevelDisplayName(
            this.subjects,
            subjectId,
            levelId
        );
    }

    toggleSelectedCategoryEvent(eventObj: { checked: boolean; asset: Asset }) {
        this.toggleCategoryEvent.emit(eventObj);
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }
}
